import { AnalyticsContext } from '@carvana/eventable-clickstream';
import React, { useEffect, useContext } from 'react';
import * as sc from '|/app/header/impersonation-baner/impersonation-banner.styles';
import UserInitializationContext from '|/app/user-initialization-context';

const ImpersonationBanner = () => {
  const { accessToken } = useContext(UserInitializationContext);
  const { user = null } = accessToken || {};
  const { trackEvent } = useContext(AnalyticsContext);

  useEffect(() => {
    if (user?.is_impersonating?.toLowerCase() === 'true') {
      trackEvent('header - banner - viewed banner', {
        bannerType: 'impersonation-banner'
      });
    }
  }, [trackEvent, user]);

  if (user === null || user?.is_impersonating?.toLowerCase() !== 'true')
    return null;

  return (
    <sc.Wrapper>
      <sc.ImpersonationBanner data-testid="impersonation-banner">
        <p>
          Currently Impersonating User:{' '}
          <strong>
            {user?.given_name} {user?.family_name}
          </strong>
        </p>
        <a
          href={`/manageuser/deimpersonate?i=userdetails&returnUrl=/managecustomer?userid=${user?.user_id}`}
          target="_self"
          aria-label="stop impersonating"
          onClick={() => {
            trackEvent('header - banner - dismissed banner', {
              bannerType: 'impersonation-banner'
            });
          }}
          data-analytics-id="pp_impersonation_stop"
        >
          Stop
        </a>
      </sc.ImpersonationBanner>
    </sc.Wrapper>
  );
};

export default ImpersonationBanner;
